import * as Sentry from '@sentry/browser';

const meta = document.querySelector('meta[name="sentry-config"]');
if (meta) {
  const config = JSON.parse(meta.content);

  Sentry.init({ dsn: config.dsn });

  Sentry.setUser({
    id: config.user_id,
    user_name: config.user_name,
  });
  Sentry.setTag('version', config.version);
  Sentry.setTag('installationName', config.installation_name);
}

window.Sentry = Sentry;
